<template>
  <div class="pa-10">
    <StudentEvaluationsDataTable />
  </div>
</template>

<script>
import StudentEvaluationsDataTable from "@/components/Utils/StudentEvaluationsDataTable.vue";
export default {
  components: {
    StudentEvaluationsDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
